import { render } from "./component_header.vue?vue&type=template&id=19b328ca&scoped=true"
import script from "./component_header.vue?vue&type=script&lang=js"
export * from "./component_header.vue?vue&type=script&lang=js"

import "./component_header.vue?vue&type=style&index=0&id=19b328ca&scoped=true&lang=scss"
import "./component_header.vue?vue&type=style&index=1&id=19b328ca&lang=scss"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b328ca"]])

export default __exports__